import 'mathlive';
import './mathlive-keyboard.css';

/**
 * Global MathLive settings shared with legacy short-answer symtools.
 * @see platform/zycommon-web/addon/utils/load-cortexjs.js
 */
if (typeof window !== 'undefined' && window.mathVirtualKeyboard) {
    window.mathVirtualKeyboard.editToolbar = 'none';
}
